<template>
	<div class="reading-content" >
		<div class="text-to-speech-container" :style="{margin:zeroMargin}" >
			<div class="play-pause">
				<span class="play-icon" @click="startReading(count += 1)" v-if="!isReading">
					<img src="https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/audio/play_circle.svg"/>
					<span class="play-pause-text" v-if="!isReading && !showAudioControls">Listen</span>
				</span>
				<span class="pause-icon" @click="stopReading()">
					<img src="https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/audio/pause_circle.svg" v-if="isReading"/>
					<span class="timer-text" v-if="showAudioControls">{{ timeStart }}</span>
					<span class="play-pause-text adjust-label" v-if="isReading">Listening</span>
					<span class="play-pause-text adjust-label" v-if="!isReading && showAudioControls">Paused</span>
				</span> 
			</div>
					
			<div class="audio-controls" v-if="showAudioControls" :style="{width:mobileAudioPlayerWidth}" >			
				<div class="custom-slider" @click="trackPosition(position)">
					<input type="range" v-model="position" min="0" :max="articleText.length" step="1">
					<span class="timer-text">{{ timeLeft }}</span>
				</div>
				<div class="rewind-image" @click="rewind()">
					<img :style="{cursor:disableCursorRewind}" src="https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/audio/audio-rewind-icon.svg"/>		
				</div>
				<div class="forward-image" @click="forward()">
					<img :style="{cursor:disableCursorFrwd}" src="https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/audio/audio-forward-icon.svg"/>
				</div>	
			</div>
		</div>
	</div>
</template>
<script>

export default {
	name: 'WebmdAudioPlayer',
	components: {},
	props:{
		articleText: {
			type: String,
			required: false,
			default: null,
		}
	},
	data() {
		return {
			voices: [],
			isReading: false,
			showAudioControls: false,
			position: 0,
			intervalId: null,
			wordsReadPerSec: 14,
			count:0,
			mobileAudioPlayerWidth:'',
			zeroMargin: '',
			secondsLeftFrwd:0,
			secondsLeftRewind:0,
			disableCursorRewind:'pointer',
			disableCursorFrwd:'pointer'
		};
	},

	computed: {
		timeLeft() {
			if(this.articleText) {
				const position = parseInt(this.position);
				if (this.articleText.length > position) {
					const wordsLeft = this.articleText.length - position;
					this.secondsLeftFrwd = wordsLeft / this.wordsReadPerSec;
					const minutesLeft = Math.floor(this.secondsLeftFrwd / 60);
					const remainingSeconds = Math.floor(this.secondsLeftFrwd % 60);
					if(this.secondsLeftFrwd < 10){
						this.disableCursorFrwd = 'not-allowed';	
					}else{
						this.disableCursorFrwd = 'pointer';
					}
					return `${minutesLeft}:${remainingSeconds < 10? '0' : ''}${remainingSeconds}`;
				}
				return '0:00'
			}
			return '';
		},

		timeStart() {
			if(this.articleText) {
				const position = parseInt(this.position);
				const wordsLeft = position;
				this.secondsLeftRewind = wordsLeft / this.wordsReadPerSec;
				const minutesLeft = Math.floor(this.secondsLeftRewind / 60);
				const remainingSeconds = Math.floor(this.secondsLeftRewind % 60);
				if(this.secondsLeftRewind < 10){
						this.disableCursorRewind = 'not-allowed';	
				}else{
					this.disableCursorRewind = 'pointer';	
				}
				return `${minutesLeft}:${remainingSeconds < 10? '0' : ''}${remainingSeconds}`;
			}
			return '';
		},
	},

	methods: {
		resetAudioControls() {
			window.addEventListener('beforeunload', () => {
				// Stop any currently playing audio
				const audioElements = document.getElementsByTagName('audio');
				for (let i = 0; i < audioElements.length; i++) {
					audioElements[i].pause();
					audioElements[i].currentTime = 0;
				}
				// Reset the speechSynthesis object
				speechSynthesis.cancel();
			});
		},

		loadVoices() {
			const loadVoices = new Promise((resolve) => {
				speechSynthesis.onvoiceschanged = () => {
					resolve(speechSynthesis.getVoices());
				};
			});
			loadVoices.then((voices) => {
				this.voices = voices;
			});
		},

		checkTTSFlag() {
			if ('SpeechSynthesisUtterance' in window && 'speechSynthesis' in window) {
				return true;
			}
			return false;
		},

		stop() {
			speechSynthesis.cancel();
		},

		startReading(count) {
			this.isReading = true;
			this.showAudioControls = true;

			const mobileBreakpoint = window.matchMedia('(max-width: 767px)');
			const tabletBreakpoint = window.matchMedia('(min-width: 768px) and (max-width: 820px)');
			const smallDesktopBreakpoint = window.matchMedia('(max-width: 1100px)');

			if (mobileBreakpoint.matches) {
				this.mobileAudioPlayerWidth = '55%';
				this.zeroMargin = '0';
			} else if (tabletBreakpoint.matches) {
				this.mobileAudioPlayerWidth = '48%';
			} else if (smallDesktopBreakpoint.matches) {
				this.mobileAudioPlayerWidth = '60%';
			}

			if (count > 1) {
				this.$vwmdPageLink({ moduleName: 'audio_Play2nd' });
			} else {
				this.$vwmdPageLink({ moduleName: 'audio_play1st' });
			}
			this.readArticle();
			this.intervalId = setInterval(() => {
				this.position = parseInt(this.position);
				this.position += this.wordsReadPerSec;
				if (this.position >= this.articleText.length) {
					this.stopReading();
				}
			}, 1000);
		},

		trackPosition(position) {
			this.stop();
			this.position = parseInt(this.position);
			if(this.isReading){
				this.readArticle();
			}
						
		},
		stopReading() {
			this.isReading = false;
			clearInterval(this.intervalId);
			this.$vwmdPageLink({ moduleName: 'audio_pause'});
			this.stop();
		},

		rewind() {
			if (this.position > 0 && this.secondsLeftRewind > 10) {
				this.stop();
				this.position -= 140;				
				if(this.isReading){
					this.readArticle();
				}
				this.$vwmdPageLink({ moduleName: 'audio_rwnd'});
			}
		},

		forward() {			
			if (this.position < this.articleText.length && this.secondsLeftFrwd > 10) {
				this.stop();
				this.position += 140;				
				if(this.isReading){
					this.readArticle();
				}	
				this.$vwmdPageLink({ moduleName: 'audio_ffwd'});				
			}
		},

		highlightWord(word, speechtext) {
			const words = speechtext.split(' ');
			const highlightedWords = words.map((w) => w === word? `<span class="highlighted">${w}</span>` : w);
			this.articleText = highlightedWords.join(' ');
		},

		readArticle(flag) {
			this.isReading = true;
			let speechtext = this.articleText.substring(this.articleText.length, this.position);
			const utterance = new SpeechSynthesisUtterance();
			utterance.text = speechtext;
			utterance.lang = 'en-US';
			utterance.pitch = 1;
			utterance.rate = 1;
			utterance.volume = 1;
			speechSynthesis.speak(utterance);
		}
	},
	mounted() {
		this.resetAudioControls();
	},
};
</script>

<style lang="scss">
$breakpoint-mobile: 47.938rem; // 767px
$breakpoint-tablet: 51.25rem; //820px
$mobile: 48rem;

.custom-slider {
	--trackHeight: 0.5rem;
	--thumbRadius: 1rem;
	margin-left: 14px;

	@media (max-width: $breakpoint-mobile) {
		margin-left: 12px;
	}

	@media (min-width: $breakpoint-mobile) and (max-width: $breakpoint-tablet) {
		margin-left: 0;
	}

	.timer-text {
		margin-left: 10px;
		position: absolute;
	}
}

/* style the input element with type "range" */

.custom-slider input[type="range"] {
	-webkit-appearance: none;
	appearance: none;
	border-radius: 12px;
	cursor: pointer;
	margin-top: 7px;
	outline: none;
	overflow: hidden;
	width: 100%;
}

.custom-slider input[type="range"]::-webkit-slider-runnable-track {
	background: #edf0ff;
	border-radius: 10px;
	height: 10px;
}

.custom-slider input[type="range"]::-moz-range-track {
	background: #edf0ff;
	border-radius: 10px;
	height: 10px;
}

.custom-slider input[type="range"]::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	background-color: #3557ff;
	box-shadow: -407px 0 0 400px #3557ff;
	height: 10px;
	width: 10px;
}

.custom-slider input[type="range"]::-moz-range-thumb {
	background-color: #3557ff;
	box-shadow: -407px 0 0 400px #3557ff;
	height: 10px;
	width: 10px;
}

.highlighted {
	background-color: yellow;
	font-weight: bold;
}

.play-icon img,
.pause-icon img {
	display: inline-block;
	height: 26px;
	width: 26px;
}

.pause-icon img {
	margin-top: -1px;

	@media (max-width: $breakpoint-mobile) {
		margin-top: -4px;
	}
}

.rewind-image,
.forward-image {
	margin-top: -40px;
	position: absolute;
	right: 27px;

	img {
		cursor: pointer;
		height: 22px;
		width: 22px;
	}
}

.forward-image {
	right: 0;
}

.play-pause {

	.play-icon,
	.pause-icon {
		align-items: center;
		cursor: pointer;
		display: inline-flex;
		justify-content: center;
	}

	.play-pause-text,
	.timer-text {
		color: #00157C;
		cursor: pointer;
		font-weight: 600;
		margin-left: 6px;
	}

	.timer-text {
		cursor: default;
		font-weight: 400;
		margin-top: 12px;
	}

	.adjust-label {
		font-weight: 600;
		margin-left: -28px;
		margin-top: -24px;
	}
}

.reading-content {
	display: flex;
	width: 100%;
}

.audio-controls {
	margin-left: 60px;
	margin-top: 10px;
	position: absolute;
	width: 65%;

	@media (min-width: $breakpoint-mobile) and (max-width: $breakpoint-tablet) {
		margin-left: 72px;
	}
}

.text-to-speech-container {
	display: flex;
	font-size: 1rem;
	margin-left: 0.5rem;
}
</style>
